import { Modal } from "react-bootstrap";
import ThemeButton from "../../theme/ThemeButton";
import styles from "./TippingModal.module.scss";
import {
    tipping1,
    tipping2,
    tipping3,
    tippingNavigate,
} from "../../../assests/Icons/icon";
import sparkleIcon from '../../../assests/sparkle.svg'

interface IProps {
    handleToggle: () => void;
    show: boolean;
    size?: any;
    onStartJourney?: () => void;
}

const TippingModal = ({
    handleToggle,
    show,
    size = "lg",
    onStartJourney,
}: IProps) => {
    const handlePrimaryAction = () => {
        handleToggle();
        onStartJourney?.();
    };

    return (
        <Modal
            show={show}
            onHide={handleToggle}
            size={size}
            className={styles.confirmationModal}
            centered
        >
            <Modal.Body>
                <div className={styles.modalContent}>
                    <h2 className={styles.modalTitle}>Welcome to TopTipper!</h2>
                    <p className={styles.modalDescription}>You’re just a few quick steps away from receiving your first tip — this takes less than 2 minutes.</p>
                    <ul className={styles.modalList}>
                        <li>
                            {tipping1} <span className={styles.modalListTitle}>Add your branding</span> to your tip page so it feels like you.
                        </li>
                        <li>
                            {tipping2} <span className={styles.modalListTitle}>Create your QR code or link</span> and test it instantly.
                        </li>
                        <li>
                            {tipping3} <span className={styles.modalListTitle}>Print or share your sign</span> to start collecting tips today.
                        </li>
                    </ul>
                    <span className={styles.modalFooterText}><img src={sparkleIcon} alt="" style={{ width: '20px', height: '20px' }} />  That’s it — you’re ready to get tipped!</span>
                    <p className={styles.modalFooterDescription}>Need help? Email us anytime at support@toptipper.co</p>

                    <ThemeButton onClick={handlePrimaryAction} className={styles.modalFooterButton}>Let's get you tipped! <span className="ml-2">{tippingNavigate
                    }</span></ThemeButton>
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default TippingModal;